import { useAuthentication } from "@tecnobit-srl/authentication";
import { useMemo } from "react";
//#region src/index.tsx
var useFormPrefillValues = (id, { defaultValue, defaultLabel, defaultNumber, defaultPrefixLabel, defaultPrefixValue } = {}) => {
	const { user } = useAuthentication();
	return useMemo(() => {
		const res = {
			defaultValue,
			defaultLabel,
			defaultNumber,
			defaultPrefixLabel,
			defaultPrefixValue
		};
		const userValue = user && id && user[id] ? user[id] : null;
		if (!userValue) return res;
		if (user) switch (id) {
			case "phone":
			case "mobilephone":
				{
					const extractedUserPhone = /^(?<prefix>\+\d+)\s+?(?<number>\d+)$/.exec(user[id] ?? "");
					if (extractedUserPhone) {
						res.defaultPrefixLabel = user[`${id}PrefixLabel`] ?? extractedUserPhone.groups?.prefix ?? "🇮🇹 +39";
						res.defaultPrefixValue = extractedUserPhone.groups?.prefix ?? "+39";
						if (extractedUserPhone.groups?.number) res.defaultNumber = extractedUserPhone.groups.number;
					}
				}
				break;
			case "country":
				res.defaultLabel = user.country.name;
				res.defaultValue = user.country.code;
				break;
			case "state":
				res.defaultLabel = user.state.name;
				res.defaultValue = user.state.code;
				break;
			case "sector":
				res.defaultLabel = user.sector?.name;
				res.defaultValue = user.sector?.id;
				break;
			case "category":
				res.defaultLabel = user.category?.name;
				res.defaultValue = user.user_category_tilelook_id ? user.user_category_tilelook_id : user.category?.id;
				break;
			case "course_district_id":
				res.defaultLabel = user.course_district_id?.name;
				res.defaultValue = user.course_district_id?.id;
				break;
			case "course_user_category_id":
				res.defaultLabel = user.course_user_category_id?.name;
				res.defaultValue = user.course_user_category_id?.id;
				break;
			case "course_tax_code":
				res.defaultValue = user.course_tax_code;
				break;
			case "course_district_sub_num":
				res.defaultValue = user.course_district_sub_num;
				break;
			default:
				res.defaultLabel = userValue;
				res.defaultValue = userValue;
		}
		return res;
	}, [
		defaultLabel,
		defaultNumber,
		defaultPrefixLabel,
		defaultPrefixValue,
		defaultValue,
		id,
		user
	]);
};
//#endregion
export { useFormPrefillValues };
